// @flow

import React from 'react';
import DatePicker from 'react-datepicker';

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

type Props = {
  name?: string,
  onChange: Function,
  className?: string,
  startDate?: Object,
  placeholderText: string,
  minDate?: Object,
  showPopperArrow?: boolean,
  disabled?: boolean,
  excludeTimes?: Array
};

class DatePickerZ extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    this.props.onChange(date);
  }

  render() {
    return (
      <DatePicker
        id="datePicker"
        showPopperArrow={this.props.showPopperArrow || false}
        name={this.props.name || ''}
        selected={this.props.startDate}
        minDate={this.props.minDate || new Date()}
        maxDate={this.props.maxDate}
        onChange={this.handleChange}
        className={this.props.className || ''}
        placeholderText={this.props.placeholderText || ''}
        timeFormat={this.props.timeFormat || 'hh:mm aa'}
        timeIntervals={15}
        dateFormat={this.props.dateFormat || 'MMM dd, yyyy'}
        showTimeSelect={this.props.showTimeSelect}
        popperClassName={this.props.popperClassName || ''}
        showMonthYearPicker={this.props.showMonthYearPicker || false}
        disabled={this.props.disabled || false}
        excludeTimes={
          this.props.excludeTimes && this.props.excludeTimes.length > 0
            ? this.props.excludeTimes
            : []
        }
      />
    );
  }
}

export default DatePickerZ;
